import { render, staticRenderFns } from "./language.vue?vue&type=template&id=2989302c"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2989302c')) {
      api.createRecord('2989302c', component.options)
    } else {
      api.reload('2989302c', component.options)
    }
    module.hot.accept("./language.vue?vue&type=template&id=2989302c", function () {
      api.rerender('2989302c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/language/language.vue"
export default component.exports